import { TEXT } from '../../../../../../helpers';

export const DashBoardHeaderConstants = {
	hello: TEXT.hello,
};
